import { useQuery } from 'react-apollo';
import { useMemo } from 'react';
import gql from './weekdays.graphql';
import useT from '../components/utils/Translations/useT';
export default function useWeekdays() {
    const t = useT();
    const { data: { weekdays = [] } = {}, error, loading } = useQuery(gql, {
        fetchPolicy: 'cache-first',
    });
    const byId = weekdays.reduce((acc, weekday) => {
        acc[weekday.id] = t(weekday.name);
        return acc;
    }, {});
    const _weekdays = useMemo(() => weekdays.map(({ name, ...rest }) => ({ ...rest, name: t(name) })), [weekdays, t]);
    return { error, loading, weekdays: _weekdays, byId };
}
